// eslint-disable-next-line import/extensions
import { customAlphabet } from 'nanoid';

export default customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
  20,
);
